<div class="__offices">
    <smvd-ui-office
        *ngFor="let office of locations; trackBy: trackBySlug"
        class="__office u-margin-bottom-lg"
        [office]="office"
        [phoneNumber]="fallbackPhoneNumber"
    >
    </smvd-ui-office>
</div>
